export type SpinnerProps = Partial<React.SVGProps<SVGSVGElement>> & {
  size?: number
  stroke?: string
}

export function Spinner(props: SpinnerProps) {
  const { size = 24, stroke = '#09cca9', ...rest } = props
  const strokeRatio = 2 / 24
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox={`0 0 24 24`}
      fill='none'
      stroke={stroke}
      strokeWidth={strokeRatio * size}
      strokeLinecap='round'
      strokeLinejoin='round'
      className='spin'
      {...rest}
    >
      <path d='M21 12a9 9 0 1 1-6.219-8.56' />
    </svg>
  )
}
